<template>
  <div class="product-header">
    <i class="iconfont icon-home"/> {{ product.title }}
  </div>
  <ProductList :product="product.children"/>
</template>

<script setup lang="ts">
import {useRoute} from "vue-router"
import {products} from "~/data/data"
import ProductList from "~/components/product-list.vue"

const route = useRoute()
const brand = route.params.cate
const type = route.query.type

function findProduct(): any {
  const targetParam = brand.split('-')
  const parent = products.find(item => item.url === `/product/${targetParam[0]}`)
  if(targetParam.length === 2) {
    return parent!.children!.find(i => i.url === `/product/${targetParam[0]}-${targetParam[1]}`)
  }
  return parent
}

const product = findProduct()
</script>

<style lang="stylus" scoped>
.product-header
  height 30px
  box-sizing border-box
  border-bottom 1px solid #EEE
  color #1e8bac
  font-size 16px
  display flex
  align-items top
  .icon-home
    margin-right 8px
    color #888
</style>

